module.exports = __webpack_public_path__ + "static/img/icon.d2a5a054.png";